import React from "react";

interface ContactInfo {
  name: string;
  title: string[];
  email: string;
  phone: string;
}

interface TextContent {
  philosophy: string;
  philosophyDescription: string;
  practicalApplication: string;
  practicalApplicationDescription: string;
  savingsInvestmentsDescription: string;
  empathyConcepts: string;
  empathyConceptsDescription: string[];
  weAreEmpathy: string;
  contacts: ContactInfo[];
}

const TEXT_CONTENT: TextContent = {
  philosophy: "Filosofi",
  philosophyDescription: `
    Att vara emotionellt intelligent handlar om att vara ”streetsmart” med sina egna resurser.
  `,
  practicalApplication: "Praktisk tillämpning",
  practicalApplicationDescription: `
    Emotioner använder vi för att få fram rätt information i olika situationer och har en tydlig effekt på den personliga utvecklingen. 
    Att lära sig att använda sina emotioner ger ofta personlig tillfredsställelse.
  `,
  savingsInvestmentsDescription: `
    Sparande och investeringar har blivit ett viktigt inslag i vår vardag. Vi utvecklar våra koncept i denna riktning och anpassar våra sparande- och investeringskoncept. 
    Sparande handlar inte bara om procent, aktier och räntesparande. Sparande är omgärdat av hur mycket du använder dina emotioner och känslor. 
    Därför har vi utvecklat ytterligare ett test för en ny tillämpning – Sparande och Emotioner.
  `,
  empathyConcepts: "Empathys koncept omfattar bland annat:",
  empathyConceptsDescription: [
    "Att utveckla metoder för självlärd praktisk träning i din aktuella miljö.",
    "Vi mäter den emotionella förmågans samverkan med ditt vardagsliv.",
    "Åtgärder och förslag är alltid baserade på dina reflektioner i kombination med emotionstestets resultat.",
    "Vi skiljer på vad som motiverar dig, stressar dig och vad som påverkar din beslutsprocess.",
    "Vi utvecklar ett program som är specifikt för dig.",
  ],
  weAreEmpathy: "Vi är Empathy",
  contacts: [
    {
      name: "Björn Johansson",
      title: [
        "Leg. Psykolog, Civ.ek. och Leg. Pedagog",
        "35 års erfarenhet av utbildning och psykologisk verksamhet.",
      ],
      email: "bjorn.johansson@empathy.nu",
      phone: "+46705696801",
    },
    {
      name: "Håkan Johansson",
      title: [
        "Fil. Kand. Nationalekonomi och Statistik",
        "37 års erfarenhet av den finansiella sektorn, Entreprenör och Styrelsearbetare",
      ],
      email: "hakan.johansson@empathy.nu",
      phone: "+46737009371",
    },
  ],
};

const Section: React.FC<{ title: string; description: string }> = ({
  title,
  description,
}) => (
  <div>
    <h3 className="font-nunito text-[32px] font-semibold leading-[48px]">
      {title}
    </h3>
    <p className="font-quicksand text-[16px] font-normal leading-[24px] mt-4">
      {description}
    </p>
  </div>
);

const ContactList: React.FC<{ contacts: ContactInfo[] }> = ({ contacts }) => (
  <>
    {contacts.map(({ name, title, email, phone }, index) => (
      <div key={index} className="mt-4">
        <p className="font-nunito text-[24px] font-semibold leading-[32px]">
          {name}
        </p>
        <ul className="list-disc pl-5 mt-2 font-quicksand text-[16px] font-normal leading-[24px] whitespace-pre-wrap">
          {title.map((line, i) => (
            <li key={i}>{line}</li>
          ))}
          <li>
            <a
              href={`mailto:${email}`}
              className="underline text-white"
              tabIndex={-1}
            >
              {email}
            </a>
          </li>
          <li>
            <a href={`tel:${phone}`} className="text-white" tabIndex={-1}>
              {phone}
            </a>
          </li>
        </ul>
      </div>
    ))}
  </>
);

const AboutUs: React.FC = () => {
  const {
    philosophy,
    philosophyDescription,
    practicalApplication,
    practicalApplicationDescription,
    savingsInvestmentsDescription,
    empathyConcepts,
    empathyConceptsDescription,
    weAreEmpathy,
    contacts,
  } = TEXT_CONTENT;

  return (
    <div className="flex flex-col justify-center items-center text-white text-start">
      <div className="max-w-[1260px] p-7 pt-2 px-2 flex flex-col gap-[30px] bg-primary-card">
        <Section title={philosophy} description={philosophyDescription} />
        <div>
          <h3 className="font-nunito text-[32px] font-semibold leading-[48px]">
            {practicalApplication}
          </h3>
          <p className="font-quicksand text-[16px] font-normal leading-[24px] mt-4">
            {practicalApplicationDescription}
          </p>
          <p className="font-quicksand text-[16px] font-normal leading-[24px] mt-4">
            {savingsInvestmentsDescription}
          </p>
        </div>
        <div>
          <h3 className="font-nunito text-[32px] font-semibold leading-[48px]">
            {empathyConcepts}
          </h3>
          <ul className="list-disc pl-5 mt-4 font-quicksand text-[16px] font-normal leading-[24px]">
            {empathyConceptsDescription.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="font-nunito text-[32px] font-semibold leading-[48px]">
            {weAreEmpathy}
          </h3>
          <ContactList contacts={contacts} />
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
